import { MILLISECONDS_IN_DAY, MILLISECONDS_IN_MINUTE } from 'src/app/utils/date.util';
import { Orgianization } from '../orgianization.entity/orgianization';
export enum EAccountStatus {
  ENABLED,
}
export enum EGroupSanguin {
  A_PLUS,
  A_MOINS,
  B_PLUS,
  B_MOINS,
  AB_PLUS,
  AB_MOINS,
  O_PLUS,
  O_MOINS,
}
export enum EUserRole {
  PATIENT,
  DOCTOR,
  DOCTOR_SECRETARY,
  PHARMACIST,
  BIOLOGIST,
  RADIOLOGIST,
  ADMIN,
  CLINIQUE_ADMIN,
  ASSISTANCE,
}
export enum EUserGender {
  HOMME,
  FEMME,
}
export enum UserCivility {
  UNKNOWN,
  MD,
  M,
  DR,
  PR,
}
export enum EUserSocialCivility {
  SIGNLE,
  MARIED,
  DIVORCED,
}
export enum EpediatricVaccinations {
     NOT_HAVE,
        CONSULTATION_PEDIATRIC_VACCINATIONS,
        PATIENT_PEDIATRIC_VACCINATIONS,
}
export interface IUser {
  id: string;
  firstName: string;
  lastName: string;
  email: string | null;
  country: string;
  address: string;
  government: string;
  city: string;
  mobilePhone1: string;
  mobilePhone2: string;
  birthDate: Date;
  gender: EUserGender;
  socialCivility: EUserSocialCivility;
  sanguineGroup: EGroupSanguin;
  assuranceType: string;
  assuranceName: string;
  assuranceReference: string;
  avatar: string;
  role: EUserRole;
  password?: string;
  accessToken?: string;
  orgianization: Orgianization | null;
  accountStatus: EAccountStatus;
  isAccompaniment: boolean;
  enabled: boolean;
  uniqueCode: string;
  cnamCode: string;
  language: string;
  colorCodeAct: string;
  actionplan: boolean | null;
  actionReduction: boolean | null;
  poidsNaissance: number;
  tailleNaissance: number;
}
export class User implements IUser {
  id: string;
  firstName: string;
  lastName: string;
  email: string | null;
  country: string;
  address: string;
  government: string;
  city: string;
  mobilePhone1: string;
  mobilePhone2: string;
  birthDate: Date;
  gender: EUserGender;
  socialCivility: EUserSocialCivility;
  sanguineGroup: EGroupSanguin;
  assuranceType: string;
  assuranceName: string;
  assuranceReference: string;
  avatar: string;
  role: EUserRole;
  accessToken?: string | undefined;
  orgianization: Orgianization | null;
  accountStatus: EAccountStatus;
  isAccompaniment: boolean;
  enabled: boolean;
  cnamCode: string;
  uniqueCode: string;
  language: string;
  colorCodeAct: string;
  actionplan: boolean | null;
  actionReduction: boolean | null;
poidsNaissance: number = 0;
tailleNaissance: number = 0;
  static calculateAge(user: User, date: Date): { years: number; months: number; days: number } {
    let ageInMilliseconds = date.getTime() - user.birthDate.getTime();
    const millisecondsPerDay = 24 * 60 * 60 * 1000;
    const millisecondsPerMonth = 30.44 * millisecondsPerDay;
    const millisecondsPerYear = 365.25 * millisecondsPerDay;
    let years = Math.floor(ageInMilliseconds / millisecondsPerYear);
    let remainingMilliseconds = ageInMilliseconds % millisecondsPerYear;
    let months = Math.floor(remainingMilliseconds / millisecondsPerMonth);
    remainingMilliseconds %= millisecondsPerMonth;
    let days = Math.floor(remainingMilliseconds / millisecondsPerDay);
    return { years: years, months: months + years * 12, days: days + years * 360 + months * 30 };
  }
  static calculateAgeInWeeks(user: User, date: Date): { years: number; months: number; days: number; weeks: number } {
    let birthDate = user.birthDate;
    let years = date.getFullYear() - birthDate.getFullYear();
    let months = date.getMonth() - birthDate.getMonth();
    let days = date.getDate() - birthDate.getDate();
    if (days < 0) {
      months--;
      let previousMonth = new Date(date.getFullYear(), date.getMonth(), 0);
      days += previousMonth.getDate();
    }
    if (months < 0) {
      years--;
      months += 12;
    }
    let totalDays = years * 365 + months * 30 + days;
    let weeks = Math.floor(totalDays / 7);
    return { years, months, days, weeks };
  }
  get old(): number {
    let d = new Date(this.birthDate);
    let age = new Date().getFullYear() - d.getFullYear();
    var m = new Date().getMonth() - d.getMonth();
    if (m < 0 || (m === 0 && new Date().getDate() < d.getDate())) {
      age = age - 1;
    }
    return age;
  }
  getAgeInMonths(birthDate: Date): number {
    const today = new Date();
    const birth = new Date(birthDate);
    let months = (today.getFullYear() - birth.getFullYear()) * 12 + (today.getMonth() - birth.getMonth());
    if (today.getDate() < birth.getDate()) {
      months--;
    }
    return months;
  }

  /**
   * NOUVEAU : âge en années décimales (ex: 8 ans et 6 mois -> 8.5).
   * Utilisé désormais par classifyBMI pour dispatcher correctement,
   * au lieu de passer des MOIS bruts dans des conditions pensées en ANNÉES.
   */
  private getAgeInDecimalYears(birthDate: Date): number {
    return this.getAgeInMonths(birthDate) / 12;
  }

  get calculateAge(): { years: number; months: number; days: number } {
    let ageInMilliseconds = Date.now() - this.birthDate.getTime();
    const millisecondsPerDay = 24 * 60 * 60 * 1000;
    const millisecondsPerMonth = 30.44 * millisecondsPerDay;
    const millisecondsPerYear = 365.25 * millisecondsPerDay;
    let years = Math.floor(ageInMilliseconds / millisecondsPerYear);
    let remainingMilliseconds = ageInMilliseconds % millisecondsPerYear;
    let months = Math.floor(remainingMilliseconds / millisecondsPerMonth);
    remainingMilliseconds %= millisecondsPerMonth;
    let days = Math.floor(remainingMilliseconds / millisecondsPerDay);
    return { years: years, months: months + years * 12, days: days + years * 360 + months * 30 };
  }
  get calculateAgeweeks(): { years: number; months: number; days: number; weeks: number } {
    let birthDate = this.birthDate;
    let today = new Date();
    let years = today.getFullYear() - birthDate.getFullYear();
    let months = today.getMonth() - birthDate.getMonth();
    let days = today.getDate() - birthDate.getDate();
    if (days < 0) {
      months--;
      let previousMonth = new Date(today.getFullYear(), today.getMonth(), 0);
      days += previousMonth.getDate();
    }
    if (months < 0) {
      years--;
      months += 12;
    }
    let totalDays = years * 365 + months * 30 + days;
    let weeks = Math.floor(totalDays / 7);
    return { years, months, days, weeks };
  }
  get yearsOld(): number {
    let birthDate = new Date(this.birthDate);
    let currentDate = new Date();
    return currentDate.getFullYear() - birthDate.getFullYear();
  }
  public getFullName(inverted?: boolean): string {
    return inverted ? this.lastName + ' ' + this.firstName : this.firstName + ' ' + this.lastName;
  }
  constructor(other?: Partial<IUser>) {
    this.id = other?.id || '';
    this.firstName = other?.firstName || '';
    this.lastName = other?.lastName || '';
    this.email = other?.email || null;
    this.country = other?.country || '';
    this.address = other?.address || '';
    this.government = other?.government || '';
    this.city = other?.city || '';
    this.mobilePhone1 = other?.mobilePhone1 || '';
    this.mobilePhone2 = other?.mobilePhone2 || '';
    this.birthDate = other?.birthDate || new Date(0);
    this.gender = Number(other?.gender) || EUserGender.HOMME;
    this.socialCivility = other?.socialCivility || EUserSocialCivility.SIGNLE;
    this.sanguineGroup = other?.sanguineGroup || EGroupSanguin.A_PLUS;
    this.assuranceType = other?.assuranceType || '';
    this.assuranceName = other?.assuranceName || '';
    this.assuranceReference = other?.assuranceReference || '';
    this.cnamCode = other?.cnamCode || '';
    this.avatar = other?.avatar || '';
    this.role = other?.role || EUserRole.PATIENT;
    this.actionplan = other?.actionplan || null;
    this.actionReduction = other?.actionReduction || null;
    this.accessToken = other?.accessToken;
    this.orgianization = other?.orgianization || null;
    this.accountStatus = other?.accountStatus || EAccountStatus.ENABLED;
    this.isAccompaniment = other?.isAccompaniment || false;
    this.enabled = other?.enabled || false;
    this.uniqueCode = other?.uniqueCode || '';
    this.language = other?.language || '';
    this.colorCodeAct = other?.colorCodeAct || '';
    this.poidsNaissance = other?.poidsNaissance || 0;
    this.tailleNaissance = other?.tailleNaissance || 0;
  }
  get fullName(): string {
    return `${this.firstName} ${this.lastName}`;
  }
  static fromResponse(res: any): User {
    return new User({
      id: res.id,
      firstName: res.firstName,
      lastName: res.lastName,
      email: res.email,
      country: res.country,
      address: res.address,
      government: res.government,
      city: res.city,
      mobilePhone1: res.mobilePhone1,
      mobilePhone2: res.mobilePhone2,
      birthDate: res.birthDate ? new Date(res.birthDate) : new Date(),
      gender: typeof res.gender === 'string' ? ['MALE', 'Feminine'].indexOf(res.gender) : Number(res.gender),
      socialCivility: res.socialCivility,
      sanguineGroup: res.sanguineGroup,
      avatar: res.avatar || res.photo || res.imageProfile,
      role: ['User', 'Medecin', 'Secretary', 'Pharmacist', 'Biologist', 'Radiologist', 'Admin', 'Clinic'].indexOf(res.userRole || res.role) as any,
      assuranceType: res.assuranceType,
      assuranceName: res.assuranceName,
      assuranceReference: res.assuranceReference,
      orgianization: res.orgianization || null,
      accountStatus: res.accountStatus,
      isAccompaniment: res.isAccompaniment,
      enabled: res.enabled,
      uniqueCode: res.uniqueCoded,
      cnamCode: res.cnamCode,
      language: res.language,
      colorCodeAct: res.colorCodeAct,
      actionplan: res.actionplan || false,
      actionReduction: res.actionReduction || false,
      poidsNaissance: res.poidsNaissance || 0,
      tailleNaissance: res.tailleNaissance || 0,
    });
  }

  // ==========================================================
  // CLASSIFICATION IMC — SECTION CORRIGÉE
  // ==========================================================

  /**
   * Fonction utilitaire commune : teste TOUJOURS le seuil "Obèse" en premier.
   * C'est le fix central : avant, plusieurs fonctions testaient le seuil
   * "Surpoids" en premier sans borne supérieure, rendant "Obèse" inatteignable.
   */
  private classifyByThresholds(
    imc: number,
    surpoidsThreshold: number,
    obeseThreshold: number,
    normalColor: string = 'green'
  ): { result: string; color: string } {
    if (imc >= obeseThreshold) {
      return { result: 'Obèse', color: 'red' };
    } else if (imc >= surpoidsThreshold) {
      return { result: 'Surpoids', color: 'orange' };
    } else {
      return { result: 'Normal', color: normalColor };
    }
  }

  classifyBMI(imc: number, birthDate: Date): { result: string; color: string } {
    // FIX : on utilise l'âge en ANNÉES DÉCIMALES (et non plus en mois bruts),
    // car toutes les conditions ci-dessous (old==6, old>=13&&old<=14, etc.)
    // sont exprimées en années.
    const old = this.getAgeInDecimalYears(birthDate);
    return this.gender == EUserGender.HOMME ? this.classifyBMIMale(imc, old) : this.classifyBMIFemale(imc, old);
  }

  classifyBMIMale(imc: number, old: number): { result: string; color: string } {
    if (old < 0.5) {
      return this.classifyBMImale0mois(imc);
    }
    if (old >= 0.5 && old <= 2) {
      return this.classifyBMImale5moisto2(imc);
    }
    if (old > 2 && old <= 4.5) {
      return this.classifyBMImale2demito4demi(imc);
    }
    if (old > 4.5 && old < 6) {
      return this.classifyBMImale5to6(imc);
    }
    if (old >= 6 && old < 7) {
      return this.classifyBMImale6demi(imc);
    }
    if (old >= 7 && old < 8) {
      return this.classifyBMImale7demi7demi(imc);
    }
    if (old >= 8 && old < 9) {
      return this.classifyBMImale8demi8(imc);
    }
    if (old >= 9 && old < 10) {
      return this.classifyBMImale9demi9(imc);
    }
    if (old >= 10 && old < 11) {
      return this.classifyBMImale10demi10ans(imc);
    }
    if (old >= 11 && old < 12) {
      return this.classifyBMImale11demi11ans(imc);
    }
    if (old >= 12 && old < 13) {
      return this.classifyBMIMaleIntervalle12(imc);
    }
    if (old >= 13 && old < 14) {
      return this.classifyBMIMaleIntervalle13to14ans(imc);
    }
    if (old >= 14 && old < 16) {
      return this.classifyBMIMaleIntervalle14ansdemi16ans(imc);
    }
    if (old >= 16 && old <= 18) {
      // FIX : on appelle désormais la fonction MASCULINE (elle existait
      // déjà mais n'était jamais utilisée), et non plus la fonction féminine.
      return this.classifyBMIMaleIntervalle116demians18ans(imc);
    }
    return this.classifyBMIMaleAdult(imc);
  }

  classifyBMIMaleUnder18(imc: number): { result: string; color: string } {
    if (imc < 18.5) {
      return { result: 'Insuffisance pondérale', color: 'blue' };
    } else if (imc < 23) {
      return { result: 'Normal', color: 'green' };
    } else {
      return { result: 'Surpoids', color: 'orange' };
    }
  }
  classifyBMIMaleAdult(imc: number): { result: string; color: string } {
    if (imc < 18.5) {
      return { result: 'Insuffisance pondérale', color: 'blue' };
    } else if (imc < 24.9) {
      return { result: 'Normal', color: 'green' };
    } else if (imc < 29.9) {
      return { result: 'Surpoids', color: 'orange' };
    } else {
      return { result: 'Obèse', color: 'red' };
    }
  }
  classifyBMIUnder1Year(imc: number): { result: string; color: string } {
    if (imc <= 16) {
      return { result: 'Faible IMC pour un enfant moins 1 an', color: 'blue' };
    } else if (imc <= 18) {
      return { result: 'IMC normal pour un enfant moins 1 an', color: 'green' };
    } else {
      return { result: 'IMC élevé pour un enfant moins 1 an', color: 'orange' };
    }
  }

  // --- Garçons : chaque fonction délègue au helper commun (fix appliqué partout) ---
  classifyBMIMaleIntervalle116demians18ans(imc: number) { return this.classifyByThresholds(imc, 25.18, 28.2, 'vert'); }
  classifyBMIMaleIntervalle14ansdemi16ans(imc: number) { return this.classifyByThresholds(imc, 24.05, 27.26, 'vert'); }
  classifyBMIMaleIntervalle13to14ans(imc: number) { return this.classifyByThresholds(imc, 23.01, 26.28, 'vert'); }
  classifyBMIMaleIntervalle12(imc: number) { return this.classifyByThresholds(imc, 22.25, 25.44, 'vert'); }
  classifyBMImale11demi11ans(imc: number) { return this.classifyByThresholds(imc, 21.43, 24.45, 'vert'); }
  classifyBMImale10demi10ans(imc: number) { return this.classifyByThresholds(imc, 20.6, 23.35, 'vert'); }
  classifyBMImale9demi9(imc: number) { return this.classifyByThresholds(imc, 19.78, 22.21, 'vert'); }
  classifyBMImale8demi8(imc: number) { return this.classifyByThresholds(imc, 19.01, 21.11, 'vert'); }
  classifyBMImale7demi7demi(imc: number) { return this.classifyByThresholds(imc, 18.34, 20.15, 'vert'); }
  classifyBMImale6demi(imc: number) { return this.classifyByThresholds(imc, 18.07, 19.75, 'vert'); }
  classifyBMImale5to6(imc: number) { return this.classifyByThresholds(imc, 17.61, 19.02, 'vert'); }
  classifyBMImale2demito4demi(imc: number) { return this.classifyByThresholds(imc, 17.76, 18.92, 'vert'); }
  classifyBMImale5moisto2(imc: number) { return this.classifyByThresholds(imc, 18.66, 19.72, 'vert'); }
  classifyBMImale0mois(imc: number) { return this.classifyByThresholds(imc, 14.28, 15.01, 'vert'); }
  classifyBMImale1ans1demi(imc: number) { return this.classifyByThresholds(imc, 18.25, 19.22, 'vert'); }
  classifyBMImale5mois(imc: number) { return this.classifyByThresholds(imc, 17.95, 18.85, 'vert'); }

  classifyBMIFemale(imc: number, old: number): { result: string; color: string } {
    if (old < 0.5) {
      return this.classifyBMIFemale0(imc);
    }
    if (old >= 0.5 && old < 1.5) {
      return this.classifyBMIFemale1ans1demi(imc);
    }
    if (old >= 1.5 && old < 2.5) {
      return this.classifyBMIFemale2(imc);
    }
    if (old >= 2.5 && old < 4.5) {
      return this.classifyBMIFemale2demi4demi(imc);
    }
    if (old >= 4.5 && old < 6.5) {
      return this.classifyBMIFemale5demi6demi(imc);
    }
    if (old >= 6.5 && old < 8) {
      return this.classifyBMIFemale6demi7demi(imc);
    }
    if (old >= 8 && old < 9) {
      return this.classifyBMIFemale8(imc);
    }
    if (old >= 9 && old < 10) {
      return this.classifyBMIFemale9demi10ans(imc);
    }
    if (old >= 10 && old < 11) {
      return this.classifyBMIFemale10demi11ans(imc);
    }
    if (old >= 11 && old < 13) {
      return this.classifyBMIfemaleIntervalle11ans(imc);
    }
    if (old >= 13 && old < 14) {
      return this.classifyBMIfemaleIntervalle13ans(imc);
    }
    if (old >= 14 && old < 16) {
      return this.classifyBMIFemale14ans16ans(imc);
    }
    if (old >= 16 && old <= 18) {
      return this.classifyBMIFemale16demians18ans(imc);
    }
    return this.classifyBMIFemaleAdult(imc);
  }

  classifyBMIFemaleUnder18(imc: number): { result: string; color: string } {
    if (imc < 18.5) {
      return { result: 'Insuffisance pondérale', color: 'blue' };
    } else if (imc < 23) {
      return { result: 'Normal', color: 'green' };
    } else {
      return { result: 'Surpoids', color: 'orange' };
    }
  }
  classifyBMIFemaleAdult(imc: number): { result: string; color: string } {
    if (imc < 18.5) {
      return { result: 'Insuffisance pondérale', color: 'blue' };
    } else if (imc < 24.9) {
      return { result: 'Normal', color: 'green' };
    } else if (imc < 29.9) {
      return { result: 'Surpoids', color: 'orange' };
    } else {
      return { result: 'Obèse', color: 'red' };
    }
  }

  // --- Filles : chaque fonction délègue au helper commun (fix appliqué partout) ---
  classifyBMIFemale16demians18ans(imc: number) { return this.classifyByThresholds(imc, 25.02, 27.69); }
  classifyBMIFemale14ans16ans(imc: number) { return this.classifyByThresholds(imc, 24.05, 27.01); }
  classifyBMIfemaleIntervalle13ans(imc: number) { return this.classifyByThresholds(imc, 23.33, 26.33); }
  classifyBMIfemaleIntervalle11ans(imc: number) { return this.classifyByThresholds(imc, 22.04, 25); }
  classifyBMIFemale10demi11ans(imc: number) { return this.classifyByThresholds(imc, 21.2, 24.03); }
  classifyBMIFemale9demi10ans(imc: number) { return this.classifyByThresholds(imc, 20.42, 23.04); }
  classifyBMIFemale8demi9demi(imc: number) { return this.classifyByThresholds(imc, 19.65, 22.01); }
  classifyBMIFemale8(imc: number) { return this.classifyByThresholds(imc, 19.25, 21.47); }
  classifyBMIFemale6demi7demi(imc: number) { return this.classifyByThresholds(imc, 18.21, 20.01); }
  classifyBMIFemale5demi6demi(imc: number) { return this.classifyByThresholds(imc, 17.69, 19.16); }
  classifyBMIFemale2demi4demi(imc: number) { return this.classifyByThresholds(imc, 17.76, 18.92); }
  classifyBMIFemale2(imc: number) { return this.classifyByThresholds(imc, 17.92, 19.03); }
  classifyBMIFemale1ans1demi(imc: number) { return this.classifyByThresholds(imc, 18.25, 19.22); }
  classifyBMIFemale5mois(imc: number) { return this.classifyByThresholds(imc, 17.95, 18.85); }
  classifyBMIFemale0(imc: number) { return this.classifyByThresholds(imc, 14.12, 14.81); }
}